import { useState } from "react";
import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from "./Modal";
import { RoomType } from "@prisma/client";
import Star from "@app/icons/Star";
import useUser from "@app/zustand/user";

type OnboardingProps = {
  open: boolean;
  onClose: () => void;
};

export default function Onboarding({ open, onClose }: OnboardingProps) {
  const me = useUser((state) => state.user!);
  const [step, setStep] = useState(0);
  const channels = me.rooms.filter((r) => r.room.roomType !== RoomType.DIRECT);

  return (
    <ModalContainer open={open} onClose={onClose} blurryBackground onAfterLeave={() => setStep(0)}>
      {step === 0 && (
        <>
          <ModalHeader title="Welcome tooo MedSpot.fr&nbsp;!&nbsp;🩺" />
          <ModalBody className="flex flex-col items-center overflow-y-auto sm:p-8">
            <p className="w-full px-4 text-center">Pour ou contre les crocs en dehors de l'hôpital ?</p>
            <img src="/crocs.jpeg" className="mx-auto my-4 w-[70vw]" alt="bele paire de crocs" />
            <Button onClick={() => setStep(1)} value="faute de style">
              🤮 C’est non ! Faute de style majeure
            </Button>
            <Button onClick={() => setStep(1)} value="fan">
              🤩 C’est oui ! Je suis fan
            </Button>
            <Button onClick={() => setStep(1)} value="courses">
              😗 Ça va, ça ne me choque pas,
              <br />
              ok pour aller faire des courses
            </Button>
            <Button onClick={() => setStep(1)} value="maison">
              🙈 Ok mais seulement à la maison&nbsp;!
            </Button>
            <Button onClick={() => setStep(1)} value="jardin">
              👩‍🌾 Ce sont mes chaussures de jardinage&nbsp;!
            </Button>
            <Button onClick={() => setStep(1)} value="hater">
              🤬 Je hais les crocs, même à l'hôpital.
            </Button>
          </ModalBody>
        </>
      )}
      {step === 1 && (
        <>
          <ModalHeader title="Bienvenue sur ton nouveau réseau pro&nbsp;!" />
          <ModalBody className="flex flex-col items-center gap-y-4 overflow-y-auto border-t border-t-sky-900/20 py-2 sm:p-8">
            <p className="w-full px-4 text-left">Très simple, tu as 2 groupes :</p>
            <ul className="ml-4 flex list-inside flex-col items-start gap-y-1 border-l-2 border-l-sky-800 px-4 text-left">
              {channels.map((roomRelation) => {
                const room = roomRelation.room;
                return (
                  <li key={room.id} className="w-full">
                    <span className="mr-2 inline-flex size-8 shrink-0 items-center justify-center text-center text-2xl">
                      {room.roomType === RoomType.ETABLISSEMENT && "🏥"}
                      {/* {room.roomType === RoomType.SPECIALITE && "🧰"} */}
                      {/* {room.roomType === RoomType.STATUS_PRO && "🥼"} */}
                      {room.roomType === RoomType.SPECIALITE_AND_STATUS_PRO && "⚕️"}
                      {/* {room.roomType === RoomType.UNIVERSITAIRE && "🎓"} */}
                    </span>
                    <strong>{room.name}</strong>&nbsp;: {room.roomType === RoomType.ETABLISSEMENT && `CHU & périph`}
                    {/* {room.roomType === RoomType.SPECIALITE && "Les chefs & internes de ta spé"} */}
                    {/* {room.roomType === RoomType.STATUS_PRO &&
                      room.name === "Les Chefs de Clinique du CHU" &&
                      "Les Chefs de Clinique du CHU"} */}
                    {room.roomType === RoomType.SPECIALITE_AND_STATUS_PRO &&
                      "Les médecins de la même spé ET du même statut que toi"}
                    {/* {room.roomType === RoomType.UNIVERSITAIRE && "Les universitaires de ton CHU"} */}
                  </li>
                );
              })}
              {/* <li>
                <strong>Mon CHU</strong>: Les médecins et internes du CHU
              </li>
              <li>
                <strong>Ma spé</strong>: les Anesthésistes du CHU => Chefs & internes de ta spé
              </li>
              <li>
                <strong>Les internes d’anesthésie</strong> => Tous les internes de ta spé
              </li> */}
            </ul>
            <p className="w-full px-4 text-left">
              Tu peux enregistrer les posts que tu veux garder sous le coude et le voir dans{" "}
              <div
                className={[
                  "flex w-full items-center rounded-lg bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-100 hover:bg-gray-50",
                ].join(" ")}
              >
                <span className="mr-2 inline-flex size-8 shrink-0 items-center justify-center text-center text-2xl">
                  <Star filled className="pointer-events-none size-5" />
                </span>
                <span>Mes posts favoris</span>
              </div>
            </p>
            <p className="w-full px-4 text-left">
              Tu peux créer ton propre groupe pour ton stage actuel, un projet de recherche, une ligne de garde, ta
              thèse, etc...
            </p>
          </ModalBody>
          <ModalFooter>
            <button className="rounded-lg bg-sky-800 px-4 py-2 text-white" onClick={() => setStep(2)}>
              OK ça marche 🤑
            </button>
          </ModalFooter>
        </>
      )}
      {step === 2 && (
        <>
          <ModalHeader title="Welcome tooo MedSpot.fr&nbsp;!&nbsp;🩺" />
          <ModalBody className="flex flex-col items-center overflow-y-auto py-4 sm:p-8">
            <p className="w-full px-4 text-left">Plus qu’à te souhaiter la bienvenue dans ton espace&thinsp;!</p>
          </ModalBody>
          <ModalFooter>
            {/* <button className="rounded-lg bg-sky-800 px-4 py-2 text-white" onClick={() => setStep(3)}> */}
            <button className="rounded-lg bg-sky-800 px-4 py-2 text-white" onClick={onClose}>
              C'est parti&nbsp;! 🚀
            </button>
          </ModalFooter>
        </>
      )}
      {step === 3 && (
        <>
          <ModalHeader title="Active les notifications" />
          <ModalBody className="flex flex-col items-center overflow-y-auto py-4 sm:p-8">
            <p className="w-full px-4 text-left">
              Pour rester informé des dernières actualités, partages et discussions, active les notifications.
            </p>
          </ModalBody>
          <ModalFooter>
            {/* <RegisterWebPushNotificationsButton onOk={onClose} onAlreadyGood={onClose} /> */}
            <button className="bg-white-800 shrink-0 rounded-lg px-4 py-2 text-sky-800" onClick={onClose}>
              Plus tard
            </button>
          </ModalFooter>
        </>
      )}
    </ModalContainer>
  );
}

type ButtonProps = {
  children: React.ReactNode;
  onClick: () => void;
  value: string;
};

function Button({ children, onClick, value }: ButtonProps) {
  return (
    <button
      type="button"
      className={[
        "mb-1 inline-flex gap-2 rounded-lg border border-gray-300 px-4 py-1",
        "plausible-event-name=croks+name",
        `plausible-event-value=${value.split(" ").join("+")}`,
      ].join(" ")}
      onClick={() => {
        onClick();
      }}
    >
      {children}
    </button>
  );
}
